
/**
  ブランクページ（初期表示用）
*/
<template>
  <v-ons-page>
      <v-ons-toolbar class="cart-header" style="height:50px;">
        <div class="left" style="width:180px">
           <v-ons-button modifier="quiet" @click="SetCartPageVisible(false)">
             <v-ons-icon icon="fa-times"></v-ons-icon> {{ localizeLabel("Common", "close")}}
           </v-ons-button>
        </div>
        <div class="center"> </div>
        <div class="right"> </div>
      </v-ons-toolbar>
      <div class="content" style="overflow: scroll; height:100vh">
        <!--<v-ons-progress-bar indeterminate v-if="isOrderSending"></v-ons-progress-bar>-->
        
        <h4 style="margin:2rem auto 1rem">{{localizeLabel("Order", "label_cart_title")}}</h4>
        <div class="cart_list">
          <div class="cart_list--item" v-for="(item, index) in cartData" :key="index">
            <v-ons-button class="btn-delete" @click="removeItem(index)">
              <v-ons-icon size="16px" icon="fa-trash"></v-ons-icon>
            </v-ons-button>
            
            <div class="item_disabled_block" v-if="item.disabled">
              <p class="item_name">
                  {{item.name}}
              </p>
              <p class="disabled_msg">{{localizeLabel("Order", "label_menu_disabled")}}</p>
            </div>
            
            <div class="order_count_block" v-if="!item.disabled">
              <!--通常-->
              <div class="order_count_block--item normal">
                <p class="item_name">
                  {{item.name}}
                </p>
                <div class="input_form" v-if="item.request_count==0">
                  <v-ons-button class="inp_number" modifier="outline" :disabled="item.count==1" style="" @click="checkCount(cartData[index].item_info, item, item.count-1)">
                    <img src="../assets/img/ico_minus.svg" alt="">
                  </v-ons-button>
                  <input type="phone" placeholder="" readonly v-model="item.count">
                  <v-ons-button class="inp_number" modifier="outline" style="" :disabled="CheckLimitCount(item, cartData[index].item_info.OrderZan,false)<=0" @click="checkCount(cartData[index].item_info, item, item.count+1)">
                    <img src="../assets/img/ico_plus.svg" alt="">
                  </v-ons-button>
                </div>
              </div>
              <!--リクエスト-->
              <div class="order_count_block--item" v-for="(req) in item.request" :key="req.name">
                <p class="cate_name">
                  {{req.name}}
                </p>
                <div class="input_form">
                  <v-ons-button class="inp_number" modifier="outline" style="" @click="CheckCartItemRequestCount({parent:cartData[index], req_parent:item.request, item:req, count:req.request_count-1})">
                    <img src="../assets/img/ico_minus.svg" alt="">
                  </v-ons-button>
                  <input type="phone" placeholder="" readonly v-model="req.request_count">
                  <v-ons-button class="inp_number" modifier="outline"  :disabled="CheckRequestLimitCount(item.request, cartData[index].item_info,false)<=0" @click="CheckCartItemRequestCount({parent:cartData[index], req_parent:item.request, item:req, count:req.request_count+1})">
                    <img src="../assets/img/ico_plus.svg" alt="">
                  </v-ons-button>
                </div>
              </div>
              <!--構成品-->

              <div v-for="(category, index) in item.category_list" :key="index">
                <div v-for="(config) in category.configList" :key="config.category_name">
                      <p class="topping_text"><strong class="count">{{index+1}}品目</strong>の{{config.category_name}} <span v-if="config.select_mode==0">（任意選択）</span></p>
                      <div v-if="currentLangCode=='ja'">
                        <p v-if="config.select_mode==1 && config.last_count>0" class="topping_text">{{config.category_name}} をあと{{ config.last_count }}つ選んでください</p>
                      </div>
                      <div v-if="currentLangCode=='en'">
                        <p v-if="config.select_mode==1 && config.last_count>0" class="topping_text">Please select {{ config.last_count }} more {{config.category_name}}</p>
                      </div>
                      <div v-if="currentLangCode=='ch'">
                        <p v-if="config.select_mode==1 && config.last_count>0" class="topping_text">请再选择 {{ config.last_count }}个 {{config.category_name}}</p>
                      </div>
                      <div class="order_count_block--item" :class="{selected:cate.count>0}" v-for="(cate) in config.category_item"  :key="cate.name" @click="checkConfigSelected(config,cate)">
                        <div class="cate_name">
                           <div class="selected_caption" v-if="config.limit_count==1 && cate.count>0">
                            <v-ons-icon icon="fa-check-circle"></v-ons-icon>
                          </div>
                          {{cate.name}}
                        </div>
                        <div class="input_form" v-if="config.limit_count!=1">
                          <v-ons-button class="inp_number" modifier="outline" style="" @click="checkChildCount(config, item, cate, cate.count-1)">
                            <img src="../assets/img/ico_minus.svg" alt="">
                          </v-ons-button>
                          <input type="phone" placeholder="" readonly v-model="cate.count">
                          <v-ons-button class="inp_number" modifier="outline" style="" @click="checkChildCount(config, item, cate, cate.count+1)" :disabled="cate.add_disabled">
                            <img src="../assets/img/ico_plus.svg" alt="">
                          </v-ons-button>
                        </div>
                      </div>

                </div>
              </div>

            </div>
          </div>
        </div>
        <v-ons-popover cancelable
          :visible.sync="popoverVisible"
          :target="popoverTarget"
          direction="up"
          cover-target="false"
        >
          <p style="text-align: center" v-html="popoverMessage"></p>
        </v-ons-popover>
        <div class="bottom_toolbar">
         <v-ons-button modifier="large" class="btn-order" @click="CommitOrder" style="margin: 6px 0" :disabled="checkOrderable">{{localizeLabel("Order", "label_commit_order")}}</v-ons-button>
        </div>
      </div>
  </v-ons-page>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from 'moment'

export default {
  name: 'CartPage',
  props:{
    cartData: { type: Array, default: [] },
  },
  data() {
    return {
      isOrderSending: false,
      popoverVisible:false,
      popoverTarget:null,
      popoverMessage:'',
    }
  },
  created: function() {
    //debugger
    
  },
  updated:function(){
    
  },
  computed: {
    ...mapGetters([
      'CartPageVisible',
      'localizeLabel',
      'currentLangCode',
      'SlipInfo',
       "localizeLabel",
       'CheckLimitCount',
       'CheckRequestLimitCount',
       'CheckCategoryLimitCount',
       'SubMenuList',
       'GetSubmenuByCode',
       'CheckSubmenuSendLimit',
       'CheckCartLockTime',
       'CheckSubmenuEndtime',
       'CartItemCount',
      ]),
      checkOrderable(){
        
        var result=false
        if(this.isOrderSending){
          result= true
        }
        
        this.cartData.forEach(function(item){

          if(item.count==0){
            return true
          }
          var is_condition_clear=true
          item.category_list.forEach(function(orderCate){
            orderCate.configList.forEach(function(config){
              //lastcountが０でなければオーダ不可
              if(config.last_count>0 && config.select_mode==1){
                is_condition_clear=false
              }
              /*
              config.category_item.forEach(function(item){
                  if(item.add_disabled==false){
                    //1つでもdisabledがあればオーダー不可
                    is_condition_clear=false
                  }
              })
              */
            })
          })
          if(is_condition_clear==false){
            result= true
          }else{
            //result=false
          }
        })

        return result


        
      },
  },
  methods: {
    ...mapActions([
      'SetCartPageVisible',
      'showMessage',
      'showErrorMessage',
      'SendOrder',
      'CheckCartItemCount',
      'CheckCartItemRequestCount',
      'CheckCartCategoryItemCount',
      'saveCartData',
      'setLoadingScreenVisibility',
      
    ]),
    //構成品がセレクトモードの時に行をクリックした際のイベント
    checkConfigSelected(config,item){
      if(config.limit_count==1){
        var count=0
        config.category_item.forEach(function(cate){
          if(cate.code==item.code && item.count==0){
              cate.add_disabled=false
              cate.count=1
              count++
          }else{
            cate.count=0
            cate.add_disabled=true
          }
        })
        config.last_count=config.limit_count-count
      }
    },
    initOrderCategoryList(order_count,cart_item){
      cart_item.category_list=[]
      //構成品の初期化
      for(var i=0; i<order_count; i++){
        
        var configList=[]
        if(cart_item.item_info.ConfigCount>0){
          const self=this

          if(!Array.isArray(cart_item.item_info.ConfigLists.ConfigList)){
            //構成品が1つの時　無理矢理配列にする
            var temp=JSON.parse(JSON.stringify(cart_item.item_info.ConfigLists.ConfigList))//値渡しコピー
            cart_item.item_info.ConfigLists.ConfigList=[]
            cart_item.item_info.ConfigLists.ConfigList.push(temp)
          }


          cart_item.item_info.ConfigLists.ConfigList.forEach(function(config){
            
            var categoryItems=[]
            config.CategolyItems.CategolyItem.forEach(function(item){
                categoryItems.push({ code: item.Goods, name: item.GoodsName, count: 0, add_disabled: false})
            })

            //残り選択数の計算
            //config.last_count=Number(self.categoryItem.limit_count)
            configList.push({ 
              last_count: config.LimitCount,
              select_mode: config.SelectMode, 
              limit_count: config.LimitCount,
              category_name:config.CategolyName,
              category_item: categoryItems,
            })
          })

          cart_item.category_list.push({ configList:configList})
        }

      }

            
    },
    removeItem(index){
      this.cartData.splice(index,1)
      this.saveCartData(this.cartData)
      if(this.cartData.length==0){
        this.SetCartPageVisible(false)
      }
    },
    checkCount(parent, cartItem, count){
      this.CheckCartItemCount(
        {
          parent: parent, 
          item: cartItem, 
          count: count
        }
      )
      //構成品数量リセット
      this.initOrderCategoryList(count,cartItem)
      /*
      if(parent.ConfigCount>0){
        cartItem.last_count=(cartItem.count*Number(parent.ConfigLists.ConfigList.LimitCount))
        cartItem.category.forEach(function(item){
          item.count=0
        })
      }*/
    },

    checkChildCount(config, cartItem, item, count){
      this.CheckCartCategoryItemCount(
        {
          parent: cartItem.item_info, 
          cate_parent: cartItem, 
          items: config.category_item, 
          item: item, 
          count: count
        }
      )
      var order=0

      config.category_item.forEach(function(cate){
        order=order+Number(cate.count)
      })
      //残り選択数の計算
      //cartItem[select_mode]=parent.ConfigLists.ConfigList.SelectMode
      //cartItem[cate_name]=parent.ConfigLists.ConfigList.CategoryName
      
      config.last_count=Number(config.limit_count)-order

      this.checkTotalLimitCount(cartItem)
    },
    checkTotalLimitCount(cartItem){
      var self=this
      //全商品でLimitを再チェックする
      cartItem.category_list.forEach(function(orderCate){
          orderCate.configList.forEach(function(config){
            var order=0
            config.category_item.forEach(function(item){
              order=order+Number(item.count)
            })
            config.category_item.forEach(function(item){
                item.add_disabled= self.CheckCategoryLimitCount(config, order)
            })
          })
      })

      
    },
    CommitOrder(){
      var validate=true
      var self=this
      this.isOrderSending=true
     //放題メニューSendLimitとLockTimeチェック
     this.SubMenuList.forEach(function(item){
       if(self.CheckSubmenuSendLimit(item, 0)<0){
         self.popoverVisible=true
          self.popoverTarget=event
          self.popoverMessage=item.GoodsName+"で<br>一度に注文できるのは<br>"+item.SendLimit+"品までです"
          validate=false
       }
       if(self.CheckCartLockTime(item)==false){
         self.popoverVisible=true
         self.popoverTarget=event
         self.popoverMessage=item.GoodsName+"の商品はもう少し時間をおいてからご注文ください"
         validate=false
       }
       //制限時間チェック
        if(self.CheckSubmenuEndtime(item)==false){
          self.popoverVisible=true
          self.popoverTarget=event
          self.popoverMessage=item.GoodsName+"の商品は制限時間が過ぎているため注文できません"
          validate=false
        }
       
     })
     
     //伝票の制限時刻をチェックする
     /*
     if(Number(this.SlipInfo.LimitTime)!=0){
        //var endtime=moment(moment().format('YYYYMMDD')+this.SlipInfo.LimitTime,'YYYYMMDDHHmmss')
        var endtime=moment(this.SlipInfo.LimitDate+this.SlipInfo.LimitTime,'YYYYMMDDHHmmss')
        if(moment()>endtime){
            self.popoverVisible=true
            self.popoverTarget=event
            self.popoverMessage="最終オーダー時間が過ぎているため注文できません"
            validate=false
        }
     }*/
     
     if(Number(this.SlipInfo.Status)!=0){
       this.popoverVisible=true
        self.popoverTarget=event
        this.popoverMessage=this.localizeLabel('POS_STATUS',this.SlipInfo.Status)
        validate=false
     }
     if(validate){
        //オーダーを確定する
        this.setLoadingScreenVisibility(true)
        this.SendOrder(this.cartData)
        .then(result=>{
          this.showMessage(result)
          this.setLoadingScreenVisibility(false)
          this.SetCartPageVisible(false)
          this.isOrderSending=false
        })
        .catch(error=>{
          this.SetCartPageVisible(false)
          this.setLoadingScreenVisibility(false)
          this.showErrorMessage(error)
          this.isOrderSending=false
        })
     }else{
       this.isOrderSending=false
     }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
@import "../assets/sass/base.scss";

.content{
  padding: 10px 10px 180px;
  //background-color: #111!important;
  background: $background-image-path!important;
  background-size: cover!important;
  color: $base-font-color;
}
ons-toolbar{
    //background: black;
    background: $header-bg;
    color: $header-font-color;
    border-bottom: 1px solid gray;
    ons-button{
      color: $header-font-color!important;
    }
  }
input{
    box-sizing: border-box;
    width: 50%;
    flex: 1;
    border: 1px solid #ccc;
    margin: 0px 3px;
    border-radius: 5px;
    color: #222!important;
    text-align: center!important;
    font-size: 24px!important;
    max-width: 55px;
    height: 100%;
}
ons-button{
    color: $base-font-color;
    &.inp_number{
      min-width: 44px;
      font-size: 20px;
      text-align: center;
      border-color: $input-button-font-color;
      background-color: $input-button-color;
      display: flex;
      align-items: center;
      justify-content: center; 
    }
}
.input_form{
  display: flex;
  justify-content: flex-end;
  align-content: center;
  min-width: 150px;
  height: 40px;
  padding: 3px 0;
}

.cart_list--item{
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
  margin-bottom: 5px;
  border-bottom: 1px solid gray;
}
.item_name{
  display: block;
  font-size: 14px;
  font-weight: bold;
  margin-right: 10px;
  //min-width: 150px;
  text-align: left;
  flex: 1;
}
.cate_name{
  font-size: 12px;
  text-align: left;
  margin-right: 10px;
  display: flex;
  align-items: center;
  @media screen and (min-width: 768px) {
    font-size: 14px;
  }
}
.child_price{
  font-size: 12px;
  display:flex;
  align-items:center;
  @media screen and (min-width: 768px) {
    font-size: 14px;
  }
}
.selected_caption{
  display: inline-block;
  font-size:14px;
  text-align: right;
  line-height: 1;
  padding: 0;
  margin-right: 5px;
  @media screen and (min-width: 768px) {
    font-size: 18px;
  }
}

.order_count_block{
  //width: 70%;
  flex: 1;
  padding:8px 0;
}
.order_count_block--item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  height: 44px;
  &.normal{
    justify-content: flex-end;
  }
  &.selected{
    background-color:$selected-row-color;
    color:$selected-font-color;
    border-radius: 5px;
    font-weight: bold;
  }
}

ons-progress-bar {
  position: absolute;
  top: 6px;
  width: 100%;
}

.btn-delete{
  height: 40px;
  width: 40px;
  min-width: 40px;
  border-radius: 30px;
  padding: 0;
  margin-right: 10px;
  margin-top: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $input-button-font-color;
  background-color: $delete-button-color;
}
.item_disabled_block{
  flex: 1;
  color: red;
  font-size: 14px;
  display: flex;
  align-items: center;
  .item_name{
    margin:0 0 0 10px;
    width: 50%;
  }
  .disabled_msg{
    width: 50%;
    text-align:right;
    margin: 0;
  }
}
.bottom_toolbar{
  background: $button-container-color;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  z-index: 100;
}

.topping_text{
  font-size: 14px;
  color: $primary-color;
  padding-bottom:5px;
  border-bottom: dotted 1px silver;
}
.btn-order{
  color: $input-button-font-color;
  background-color:$button-color;
}
strong.count{
  font-size: 16px;
}
/****************************/
</style>



// WEBPACK FOOTER //
// src/pages/CartPage.vue